import { Grid, Paper } from '@mui/material'
import { FormElementTitle } from '../common/FormElementTitle'
import { formComponentTypes } from '../components/formComponentTypes'
import { formElementsWithoutCardInPrintView } from '../editor/GroupElement'

export const FormElementForReadOnly = ({
  xs = 12,
  item,
  langVersion,
  connectedMap,
  describeMap,
  muBag,
  index,
  skipCard,
  lastInSection,
  paddingStyles,
  label,
  tooltipLabel,
  helptextLabel,
  ...props
}) => {
  const type = item.elementType
  const elementData = formComponentTypes[type]
  const { elementType } = item

  const alt = item.altLabelPlacement
  if (elementData.formComponentReadOnly) {
    let printRender = (
      <Grid 
        container 
        direction={alt ? 'row' : 'column'} 
        wrap='nowrap' 
        alignItems={alt ? 'center' : 'initial'}
      >
        <FormElementTitle
          title={label}
          helpText={!elementData?.customHelptext && helptextLabel}
          tooltip={tooltipLabel}
          id={item.id}
          altLabelPlacement={alt}
          targetFormType='printable'
          type={elementType}
        />
        {elementData.formComponentReadOnly({
          ...item,
          describeMap,
          title: label,
          connectedMap,
          editMode: false,
          muBag,
          langVersion,
          tooltip: tooltipLabel,
          ...props
        })}
      </Grid>
    )

    if (formElementsWithoutCardInPrintView.includes(elementType)) {
      if (!skipCard) {
        printRender = (
          <div style={{}}>{printRender}</div>
        )
      }
    } else {
      if (!skipCard) {
        const containerStyle = {
          padding: 0
        }
        if (lastInSection) {
          containerStyle.paddingBottom = 0
        }

        printRender = (
          <Paper
            className='form-card-container'
          >
            {printRender}
          </Paper>
        )
      } else {
        printRender = (
          <div style={{ width: '100%', display: 'flex' }}>
            {printRender}
          </div>
        )
      }
    }

    return (
      <Grid
        key={index}
        id={item.id}
        item
        container
        xs={xs}
        style={{
          width: '100%',
          display: 'flex'
        }}
        direction={alt ? 'row' : 'column'}
        wrap='nowrap'
      >
        {printRender}
      </Grid>
    )
  } else {
    return null
  }
}
